import React from 'react';
import urls from 'constants/urls';
import locator from 'utils/locator';
import AddressRouted from './AddressRouted';

const AddAddressRouted = props => (
  <AddressRouted {...props} lastLocation={`${urls.myDetailsPage}${locator.search}`} />
);

export default AddAddressRouted;
